import React from "react";
import { Link } from "react-router-dom";
import InnerHero from "../../components/InnerHero";
import {
  ArrowLeft,
  Dumbbell,
  Images,
  Trophy,
  Volleyball,
} from "lucide-react";

const infrastructureImages = [
  {
    src: "/Infrastructure/Sports_Gym/gym.png",
    //title: "Gymnasium",
    //alt: "KLS VDIT Gymnasium",
  },
  {
    src: "/Infrastructure/Sports_Gym/DSC_3505.png",
    //title: "Basket Ball Ground",
    //alt: "Basket Ball Ground ",
  },
  {
    src: "/Infrastructure/Sports_Gym/DSC_3508.png",
    //title: "Outdoor Sports Ground",
    //alt: "Outdoor Sports Ground",
  },
  {
    src: "/Infrastructure/Sports_Gym/DSC_3510.png",
    //title: "Fitness Equipment",
    //alt: "Fitness Equipment",
  },
];

const facilities = [
  "Modern Gymnasium",
  "Indoor Sports Facilities",
  "Outdoor Sports Grounds",
  "Volleyball Court",
  "Cricket Practice Area",
  "Fitness Training Equipment",
  "Student Recreation Facilities",
  "Sports Event Support Infrastructure",
];

const SportsGymInfrastructure = () => (
  <main>
    <InnerHero
      title="Sports & Gym Infrastructure"
      image="/Infrastructure/Sports_Gym/gym.png"
      breadcrumbs={[
        { label: "Campus Life", to: "/campus" },
        { label: "Sports & Gym", to: "/campus-life/sports-gym" },
        { label: "Infrastructure" },
      ]}
    />

    <section className="bg-surface-alt/60 border-b border-brand/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 text-xs font-sans-ui font-semibold tracking-wider text-brand">
        <Link
          to="/campus-life/sports-gym"
          className="inline-flex items-center gap-2 uppercase hover:underline"
        >
          <ArrowLeft size={14} />
          Back to Sports & Gym
        </Link>
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-10">
          <section>
            <div className="flex items-end justify-between gap-4 mb-5">
              <div>
                <h2
                  className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  <Images size={22} />
                  Sports Infrastructure Gallery
                </h2>

                <p className="text-sm text-[#3a3a3a]/80 italic mt-1">
                  Sports and fitness facilities available on campus
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              {infrastructureImages.map((image) => (
                <figure
                  key={image.src}
                  className="bg-white border border-brand/15 overflow-hidden"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>

                  {/* <figcaption className="px-4 py-3">
                    <span className="text-xs uppercase tracking-widest text-brand font-semibold">
                      {image.title}
                    </span>
                  </figcaption> */}
                </figure>
              ))}
            </div>
          </section>

          <section>
            <h2
              className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2 mb-5"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              <Dumbbell size={22} />
              Facilities
            </h2>

            <div className="bg-white border border-brand/15 p-5">
              <ul className="grid md:grid-cols-2 gap-x-6 gap-y-2 pl-5 list-disc text-sm text-[#2a2a2a]/85 leading-relaxed">
                {facilities.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </section>
        </div>

        <aside className="space-y-5">
          <div className="bg-white border border-brand/15 p-5 lg:sticky lg:top-36 self-start">
            <h4 className="text-xs uppercase tracking-widest text-brand font-semibold">
              Sports Infrastructure Facts
            </h4>

            <div className="mt-3 space-y-3 text-sm">
              <div className="flex items-center gap-2">
                <Dumbbell size={14} className="text-brand" />
                <span>
                  Gym Facility: <strong>Available</strong>
                </span>
              </div>

              <div>
                Indoor Sports: <strong>Available</strong>
              </div>

              <div>
                Outdoor Grounds: <strong>Available</strong>
              </div>

              <div>
                Fitness Training: <strong>Available</strong>
              </div>

              <div>
                Recreation Area: <strong>Available</strong>
              </div>
            </div>

            <Link
              to="/campus-life/sports-gym"
              className="block mt-5 text-center bg-brand text-surface py-2.5 text-sm font-semibold hover:bg-brand-dark transition"
            >
              Sports & Gym Overview
            </Link>

            <div className="mt-6 pt-5 border-t border-brand/10">
              <h4 className="text-xs uppercase tracking-widest text-brand font-semibold mb-3">
                Sports Facilities
              </h4>

              <ul className="space-y-1.5 text-sm text-[#2a2a2a]">
                {[
                  "Gymnasium",
                  "Indoor Sports",
                  "Outdoor Grounds",
                  "Volleyball Court",
                  "Cricket Practice",
                  "Fitness Centre",
                ].map((item) => (
                  <li key={item} className="flex items-center gap-1">
                    <Trophy size={12} className="text-brand" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </aside>
      </div>
    </section>
  </main>
);

export default SportsGymInfrastructure;
